module.exports = __webpack_public_path__ + "img/logo-user.05f1fddb.png";